<div class="exercise-wrapper row g-0">
  <div class="exc-details col">
    <div class="exc-header">
      <div class="title">{{ exercise.title }}</div>
    </div>

    <div class="exc-description">
      <div class="badges">
        <sana-tp-exercise-activity-badge
          [activityType]="exercise.activityType"></sana-tp-exercise-activity-badge>

        <div> | </div>

        <sana-tp-joint-badge
          [joints]="exercise.joints"></sana-tp-joint-badge>
      </div>

      <div class="row mt-3 gx-3">
        <div class="sana-form-control col">
          <label for="nrOfSets">Sätze *</label>

          <p-input-number
            [formControl]="getFormControlForExercise('numberOfSets', listIdx)"
            [min]="0"
            size="small"
            id="nrOfSets"
          ></p-input-number>
        </div>

        <div class="sana-form-control col">
          <label for="nrOfReps">
            <span>Wiederholungen</span>

            @if (exercise.repetitionUnitType === RepetitionUnitTypeEnum.Execution) {
              <span> (pro Satz)</span>
            } @else {
              <span> (in Sek. pro Satz)</span>
            }

            <span> *</span>
          </label>

          @if (exercise.repetitionUnitType === RepetitionUnitTypeEnum.Execution) {
            <p-select
              [formControl]="getFormControlForExercise('numberOfRepetitions', listIdx)"
              [options]="[5, 10, 15]"
              placeholder="Wiederholungen"
              size="small"
              [fluid]="true"
              id="nrOfReps"
              inputId="nrOfReps"></p-select>
          } @else {
            <p-select
              [formControl]="getFormControlForExercise('numberOfRepetitions', listIdx)"
              [options]="[30, 60]"
              placeholder="Wiederholungen"
              size="small"
              [fluid]="true"
              id="nrOfReps"
              inputId="nrOfReps"></p-select>
          }
        </div>

        <div class="sana-form-control col-12">
          <label for="descriptionShort">Notiz für Patient</label>

          <textarea
            rows="3"
            cols="50"
            pTextarea
            id="descriptionShort"
            [formControl]="getFormControlForExercise('customInstructions', listIdx)"
            pSize="small"
            [fluid]="true"></textarea>
        </div>

        @if (exercise.variationName) {
          <div
            class="col-12 mb-2"
            style="margin-top: -.875rem">
            <small class="text-muted">
              {{ exercise.variationName }}
            </small>
          </div>
        }

        @if (!isReadonly) {
          <div class="add-to-plan-btn col-auto mb-0">
            <p-button
              class="d-flex justify-content-end"
              (onClick)="removeExercise.emit(exercise.id!)"
              severity="danger"
              size="small"
              icon="pi pi-trash"
              pTooltip="Entfernt die Übung aus dem Therapieplan"
              tooltipPosition="left" />
          </div>
        }
      </div>
    </div>
  </div>
</div>
